export const documentsKeys = {
  checkPartnerSelfie: () => ['documents', 'check-partner-selfie'] as const,
};
